export const actionTypes = {
    SHOW_SELECTION_INFO_MODAL: 'SHOW_SELECTION_INFO_MODAL',
    HIDE_SELECTION_INFO_MODAL: 'HIDE_SELECTION_INFO_MODAL',
    SET_GLOBAL_MODAL: 'SET_GLOBAL_MODAL',
    CLEAR_GLOBAL_MODAL: 'CLEAR_GLOBAL_MODAL',
};

export const showSelectionInfoModal = () => ({
    type: actionTypes.SHOW_SELECTION_INFO_MODAL,
});

export const hideSelectionInfoModal = () => ({
    type: actionTypes.HIDE_SELECTION_INFO_MODAL,
});

export const setGlobalModal = ({ title, body, ctaTitle }) => ({
    type: actionTypes.SET_GLOBAL_MODAL,
    title,
    body,
    ctaTitle,
});

export const clearGlobalModal = () => ({
    type: actionTypes.CLEAR_GLOBAL_MODAL,
});



// WEBPACK FOOTER //
// /src/js/modals/modals.actions.js